import { render } from "./ModalShip_responsibles.vue?vue&type=template&id=982ceb96"
import script from "./ModalShip_responsibles.vue?vue&type=script&lang=js"
export * from "./ModalShip_responsibles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__